import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "onChange", "value", "readOnly"];
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { InputWrapper } from '../InputWrapper/InputWrapper';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const InputNumber = _ref => {
  let {
      disabled,
      onChange,
      value,
      readOnly
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleOnChange = event => {
    onChange(parseInt(event.target.value, 10) || 1);
  };
  return /*#__PURE__*/_jsx(NumberInput, Object.assign({}, rest, spacingProps, {
    disabled: disabled,
    onChange: handleOnChange,
    readOnly: disabled || readOnly,
    value: value
  }));
};
const InputNumberWrapper = props => /*#__PURE__*/_jsx(InputWrapper, Object.assign({}, props));
InputNumberWrapper.displayName = 'InputWrapper';
InputNumber.Wrapper = InputNumberWrapper;